export enum TransactionStatus {
	Pending = 1,
	Completed = 2,
	Failed = 3,
	Canceled = 4,
}